import Vue from 'vue'
import Tooltip from '~/components/builder/cb-tooltip'
import ItemTitle from '~/components/builder/cb-item-title'
import ItemLabel from '~/components/builder/cb-item-label'

Vue.component('cb-tooltip', Tooltip)
Vue.component('cb-item-title', ItemTitle)
Vue.component('cb-item-label', ItemLabel)
